// @flow

import * as React from 'react';
import classNames from 'classnames';
import './List.scss';

type ListType =
  | 'default'
  | 'question'
  | 'guide'
  | 'checkmark'
  | 'ordered'
  // Some components like the `Checklist` component internally render a List[type=list-style-none] so that the nested content doesn't have any bullet points
  | 'list-style-none';

type ListProps = {|
  ordered?: boolean,
  columns?: number,
  type?: ListType,
  id?: string,
  className?: string,
  children?: React.Node,
|};

export const List = ({
  ordered = false,
  type = 'default',
  columns = 1,
  id,
  className,
  children,
}: ListProps) => {
  // The ordered prop is set for Markdown list nodes, and the type prop can also be set
  // to "ordered" when the {% list %} tag is used. In either case, we should render
  // an <ol> instead of a <ul>.
  const tag = ordered || type === 'ordered' ? 'ol' : 'ul';

  const props = {
    id,
    className: classNames('List', type, className, {
      'List--hasMultipleColumns': columns > 1,
    }),
    style: {columnCount: columns},
  };

  return React.createElement(tag, props, children);
};
